import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Custom Spellmemorizer Banner Component
const SpellmemorizerBanner = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  borderRadius: '12px',
  padding: '16px',
  margin: '8px 0',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',
  transition: 'transform 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
    animation: 'shine 4s ease-in-out infinite',
  },
  '@keyframes shine': {
    '0%': { left: '-100%' },
    '50%': { left: '100%' },
    '100%': { left: '100%' },
  },
}));

const BrainIcon = styled(Box)(({ theme }) => ({
  width: '32px',
  height: '32px',
  background: 'linear-gradient(135deg, #ffffff, #f0f0f0)',
  borderRadius: '50%',
  position: 'relative',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '16px',
  animation: 'brainFloat 3s ease-in-out infinite',
  '@keyframes brainFloat': {
    '0%, 100%': { transform: 'translateY(0px)' },
    '50%': { transform: 'translateY(-3px)' },
  },
}));

const SpellmemorizerComponent = () => {
  const handleClick = () => {
    window.open('https://spellmemorizer.com', '_blank');
  };

  return (
    <SpellmemorizerBanner onClick={handleClick}>
      <BrainIcon>
        🧠
      </BrainIcon>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="caption"
          sx={{
            color: 'white',
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: 1.2,
            display: 'block',
          }}
        >
          spellmemorizer.com
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: 'rgba(255, 255, 255, 0.8)',
            fontSize: '12px',
            lineHeight: 1.1,
          }}
        >
          Master your spelling
        </Typography>
      </Box>
    </SpellmemorizerBanner>
  );
};

// ==============================|| TRUSTED PARTNERS MENU ITEMS ||============================== //

const trustedPartners = {
  id: "trustedPartners",
  title: "Trusted Partners",
  type: "group",
  children: [
    {
      id: "spellmemorizer",
      title: "",
      type: "custom",
      component: <SpellmemorizerComponent />,
    }
  ],
};

export default trustedPartners;
